import {
  Alert,
  AlertColor,
  Box,
  Button,
  Container,
  IconButton,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { Colors } from "helpers/Consts";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// MenuIcons
// import { ReactComponent as MenuIconChats } from "assets/svg/Menu/MenuIconChats.svg";
// import { ReactComponent as MenuIconNotifications } from "assets/svg/Menu/MenuIconNotifications.svg";
// import { ReactComponent as MenuIconFavorites } from "assets/svg/Menu/MenuIconFavorites.svg";
import { ReactComponent as MenuIconAddresses } from "assets/svg/Menu/MenuIconAddresses.svg";
// import { ReactComponent as MenuIconFeedback } from "assets/svg/Menu/MenuIconFeedback.svg";
import { ReactComponent as MenuIconExit } from "assets/svg/Menu/MenuIconExit.svg";
// import { ReactComponent as MenuIconReview } from "assets/svg/Menu/MenuIconReview.svg";
// import { ReactComponent as MenuIconPaymentMethods } from "assets/svg/Menu/MenuIconCreditCard.svg";
// import { ReactComponent as MenuIconCreditCard } from "assets/svg/Menu/MenuIconCreditCard2.svg";
import { useDispatch, useSelector } from "react-redux";
import { IProfileUpdateParams } from "types/Profile";
import { setEditedProfile, setLoginInfo } from "redux/Actions";
import { useMutationEditProfile } from "services/api/mutations/useMutationEditProfile";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { PanToolTwoTone } from "@mui/icons-material";
import { ITableCallParams } from "types/Tables";
import { useMutationAddTableCall } from "services/api/mutations/useMutationAddTableCall";
import TelefoneTextField from "ui/TelefoneTextField";
import { ICardapioAppState } from "../../redux/RootReducer";
import { getSearchParams } from "../../helpers/Utils";
import { UseQueryResult } from "react-query";
import { IShoppingBagData, ISingleShoppingBagResponse } from "../../types/ShoppingBag";


type Props = {
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
}

function Settings({shoppingBagQuery}:Props) {
  const {data:shoppingBag} = shoppingBagQuery

  const [open, setOpen] = useState<boolean>(false);
  const [mensagem, setMensagem] = useState<string>("");
  const [severity, setSeverity] = useState<AlertColor>("success");
  const [disabledChamarGarcom, setDisabledChamarGarcom] =
    useState<boolean>(false);
  const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);
  const [searchParams] = useSearchParams();
  const placeId = searchParams.get("place_id");
  const customOriginQrCode = searchParams.get("origin")
  const table = searchParams.get("table");
  const params = getSearchParams(placeId!, table, customOriginQrCode)


  const dispatch = useDispatch();
  const phoneRegExp =
    /^\s*(\d{2}|\d{0})[-. ]?(\d{5}|\d{4})[-. ]?(\d{4})[-. ]?\s*$/;
  const { mutate: editProfile, isSuccess: sucessoEdicao } =
    useMutationEditProfile();
  const formik = useFormik({
    initialValues: {
      id: loginInfo?.id ?? -1,
      name: loginInfo?.name ?? "",
      phone_number: loginInfo?.phone_number ?? "",
    } as IProfileUpdateParams,
    validationSchema: Yup.object().shape({
      phone_number: Yup.string().required("Nome é obrigatório."),
      name: Yup.string()
        .min(3, "Problema no nome")
        .required("Telefone é obrigatório."),
    }),
    enableReinitialize: true,
    onSubmit: async (values: any) => {
      await editProfile(values);
      loginInfo!.name = values.name;
      loginInfo!.phone_number = values.phone_number;
      dispatch(setEditedProfile(loginInfo));
      localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
      formik.setSubmitting(false);
      setMensagem("Perfil Editado com Sucesso");
      setOpen(true);
    },
  });

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("loginInfo");
    localStorage.removeItem("tokenKey");
    localStorage.removeItem("idGuest");
    localStorage.removeItem("table_number");
    dispatch(setLoginInfo({}));



    window.location.href = `${params}`;
  };
  const { mutate: newTableCall } = useMutationAddTableCall();
  const handleCallGarcom = () => {
    // console.log(shoppingBag && shoppingBag.length && shoppingBag[0].place_id);
    // console.log(
    //   shoppingBag && shoppingBag.length && shoppingBag[0].table_number
    // );
    if (shoppingBag && shoppingBag.table_number) {
      const tableCallParams = {
        calling: true,
        place_id: shoppingBag && shoppingBag.place_id,
        table_number:
          shoppingBag && shoppingBag.table_number,
      } as ITableCallParams;
      setMensagem("Garçom chamado com sucesso.");
      setSeverity("success");
      setOpen(true);
      setDisabledChamarGarcom(true);
      setTimeout(() => {
        setDisabledChamarGarcom(false);
      }, 120000);
      newTableCall(tableCallParams);
    } else {
      // setOpenEditTableNumberDialog(true);
      setSeverity("error");
      setMensagem("Você não está em nenhuma mesa.");
      setOpen(true);
    }
  };
  return (
    <Container sx={{ height: "100vh" }} maxWidth="lg">
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {mensagem}
        </Alert>
      </Snackbar>
      <Box p={2}>
        <Box paddingTop={"10px"} display={"flex"} sx={{ alignItems: "center" }}>
          <Box
            component="img"
            sx={{ borderRadius: "50%", height: "40px" }}
            src={require("assets/img/baseAvatarGray.png")}
            alt="Avatar"
          />
          <Box paddingLeft={5}>
            <Typography
              fontSize="0.8rem"
              fontWeight={"700"}
              color={Colors.grayTextColorDarkestDark}
            >
              {loginInfo?.name ?? ""}
            </Typography>
            {loginInfo?.name === "Visitante" && (
              <Typography
                fontSize="0.7rem"
                color={Colors.orangePrimary}
                sx={{ cursor: "pointer" }}
              >
                Por favor edite seu perfil
              </Typography>
            )}
          </Box>
        </Box>
        <Box paddingTop={2}>
          <form onSubmit={formik.handleSubmit}>
            <Box
              display={"flex"}
              sx={{
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TextField
                sx={{ marginTop: "20px", width: "50%", paddingX: 1 }}
                id="name"
                label="Digite seu nome"
                placeholder="Digite seu nome"
                variant="standard"
                type="text"
                value={formik.values.name}
                onChange={formik.handleChange}
                required
              />
              <TelefoneTextField
                id="phone_number"
                type="text"
                required
                variant="standard"
                onChange={formik.handleChange}
                label="Digite seu telefone"
                value={formik.values.phone_number}
                sx={{
                  marginTop: "20px",
                  width: "50%",
                  paddingX: 1,
                  MozAnimation: "none",
                  WebkitAppearance: "none",
                  appearance: "none",
                }}
              />
            </Box>

            {(formik.errors.phone_number || formik.errors.name) && (
              <Alert
                severity="warning"
                sx={{
                  display: "flex",
                  flexGrow: 1,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography fontSize="14px" fontWeight={700}>
                  Erro na edição
                </Typography>
              </Alert>
            )}
            <Button
              type="submit"
              color="primary"
              variant="contained"
              disabled={!(formik.isValid && formik.dirty)}
              fullWidth
              sx={{ color: "white", marginTop: "15px" }}
            >
              Salvar Perfil
            </Button>
          </form>
          <>
            {" "}
            {/* Fragment para organizar o codigo */}
            {/* <Box display='flex' alignItems='center' paddingTop={2} sx={{ cursor: 'pointer '}}>
                        <MenuIconChats fill={Colors.orangePrimary} height='30px' width='40px' />
                        <Box p={1} marginLeft={'10px'}>
                            <Typography
                                fontSize='0.8rem'
                                fontWeight={'700'}
                                color={Colors.orangePrimary}>
                                Chats
                            </Typography>
                            <Typography
                                fontSize='0.6rem'
                                color={Colors.baseTextColor}>
                                Conversas sobre os seus pedidos
                            </Typography>
                        </Box>
                        <Box flexGrow={1} />
                        <IconButton color="primary" onClick={() => { }}>
                            <ArrowForwardIosIcon fill={Colors.orangePrimary} />
                        </IconButton>
                    </Box>
                    <Box display='flex' alignItems='center' paddingTop={2} sx={{ cursor: 'pointer '}}>
                        <MenuIconNotifications fill={Colors.orangePrimary} height='30px' width='40px' />
                        <Box p={1} marginLeft={'10px'}>
                            <Typography
                                fontSize='0.8rem'
                                fontWeight={'700'}
                                color={Colors.orangePrimary}>
                                Notificações
                            </Typography>
                            <Typography
                                fontSize='0.6rem'
                                color={Colors.baseTextColor}>
                                Central de notificações e avisos
                            </Typography>
                        </Box>
                        <Box flexGrow={1} />
                        <IconButton color="primary" onClick={() => { }}>
                            <ArrowForwardIosIcon fill={Colors.orangePrimary} />
                        </IconButton>
                    </Box>
                    <Box display='flex' alignItems='center' paddingTop={2} sx={{ cursor: 'pointer '}}>
                        <MenuIconReview fill={Colors.orangePrimary} height='30px' width='40px' />
                        <Box p={1} marginLeft={'10px'}>
                            <Typography
                                fontSize='0.8rem'
                                fontWeight={'700'}
                                color={Colors.orangePrimary}>
                                Avaliações
                            </Typography>
                            <Typography
                                fontSize='0.6rem'
                                color={Colors.baseTextColor}>
                                Pedidos que você avaliou
                            </Typography>
                        </Box>
                        <Box flexGrow={1} />
                        <IconButton color="primary" onClick={() => { }}>
                            <ArrowForwardIosIcon fill={Colors.orangePrimary} />
                        </IconButton>
                    </Box>
                    <Box display='flex' alignItems='center' paddingTop={2} sx={{ cursor: 'pointer '}}>
                        <MenuIconFeedback fill={Colors.orangePrimary} height='30px' width='40px' />
                        <Box p={1} marginLeft={'10px'}>
                            <Typography
                                fontSize='0.8rem'
                                fontWeight={'700'}
                                color={Colors.orangePrimary}>
                                Feedback
                            </Typography>
                            <Typography
                                fontSize='0.6rem'
                                color={Colors.baseTextColor}>
                                Envie sua opinião sobre o aplicativo
                            </Typography>
                        </Box>
                        <Box flexGrow={1} />
                        <IconButton color="primary" onClick={() => { }}>
                            <ArrowForwardIosIcon fill={Colors.orangePrimary} />
                        </IconButton>
                    </Box> */}
          </>
          <Box
            component={Link}
            to={`/addresses${params}`}
            display="flex"
            alignItems="center"
            paddingTop={2}
            sx={{
              cursor: "pointer",
              marginTop: "12px",
              textDecoration: "none",
            }}
          >
            <MenuIconAddresses
              fill={Colors.orangePrimary}
              height="30px"
              width="40px"
            />
            <Box p={1} marginLeft={"10px"}>
              <Typography
                fontSize="0.8rem"
                fontWeight={"700"}
                color={Colors.orangePrimary}
              >
                Endereços
              </Typography>
              <Typography fontSize="0.6rem" color={Colors.baseTextColor}>
                Seus endereços de entrega
              </Typography>
            </Box>
            <Box flexGrow={1} />
            <IconButton color="primary">
              <ArrowForwardIosIcon fill={Colors.orangePrimary} />
            </IconButton>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            paddingTop={2}
            sx={{
              cursor: "pointer",
              marginTop: "12px",
              textDecoration: "none",
            }}
            onClick={disabledChamarGarcom ? () => {} : handleCallGarcom}
          >
            <PanToolTwoTone
              color={disabledChamarGarcom ? "disabled" : "primary"}
              sx={{
                height: "30px",
                width: "40px",
              }}
            />
            <Box p={1} marginLeft={"10px"}>
              <Typography
                fontSize="0.8rem"
                fontWeight={"700"}
                color={
                  disabledChamarGarcom ? Colors.disabled : Colors.orangePrimary
                }
              >
                Chamar Garçom
              </Typography>
              <Typography
                fontSize="0.6rem"
                color={
                  disabledChamarGarcom ? Colors.disabled : Colors.baseTextColor
                }
              >
                Clique aqui para chamar um garçom
              </Typography>
            </Box>
            <Box flexGrow={1} />
            <IconButton color="primary" disabled={disabledChamarGarcom}>
              <ArrowForwardIosIcon fill={Colors.orangePrimary} />
            </IconButton>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            paddingTop={2}
            sx={{ cursor: "pointer", marginTop: "12px" }}
            onClick={handleLogout}
          >
            <MenuIconExit
              fill={Colors.orangePrimary}
              height="30px"
              width="40px"
            />
            <Box p={1} marginLeft={"10px"}>
              <Typography
                fontSize="0.8rem"
                fontWeight={"700"}
                color={Colors.orangePrimary}
              >
                Sair
              </Typography>
              <Typography fontSize="0.6rem" color={Colors.baseTextColor}>
                Encerrar sessão no aplicativo
              </Typography>
            </Box>
            <Box flexGrow={1} />
            <IconButton color="primary">
              <ArrowForwardIosIcon fill={Colors.orangePrimary} />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}

export default Settings;
